import { render, staticRenderFns } from "./TheSendEmailBox.vue?vue&type=template&id=acdd313a&scoped=true"
import script from "./TheSendEmailBox.vue?vue&type=script&lang=js"
export * from "./TheSendEmailBox.vue?vue&type=script&lang=js"
import style0 from "./TheSendEmailBox.vue?vue&type=style&index=0&id=acdd313a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdd313a",
  null
  
)

export default component.exports